import { createRootRouteWithContext, Outlet, RoutePaths, ScrollRestoration } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/router-devtools';

const enableTanstackRouterDevtools = import.meta.env.DEV;

import { useAuth } from '@/app/hooks/useAuth/useAuth';
import { ConfirmationActions, ConfirmationState } from '@/components/dialog/confirmation.store';
import { DialogActions, DialogState } from '@/components/dialog/form.store';
import GlobalLoader from '@/components/loader/Loader';
import { routeTree } from '@/routeTree.gen';
import { QueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import { LucideIcon } from 'lucide-react';

export type AuthContextType = ReturnType<typeof useAuth>;
type Perms = {
  canAny: (keys: readonly string[]) => boolean;
  canAll: (keys: readonly string[]) => boolean;
};

interface ChildRoutes {
  label: string;
  id: string;
  path?: RoutePaths<typeof routeTree>;
  icon?: LucideIcon;
  title?: string;
  meta?: Record<string, unknown>;
}
export interface AppRouterContext {
  dialogFormStore: DialogState & DialogActions;
  confirmationStore: ConfirmationState & ConfirmationActions;
  childRoutes: ChildRoutes[];
  groupLabel: string;
  queryClient: QueryClient;
  perms: Perms;
  client: AxiosInstance;
  auth: AuthContextType;
}

export const Route = createRootRouteWithContext<AppRouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <>
      <ScrollRestoration />
      <GlobalLoader />
      <Outlet />
      {enableTanstackRouterDevtools && <TanStackRouterDevtools />}
    </>
  );
}
